import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image, url }) => {
    const siteTitle = 'Smile Care Dental Surgery - Implants & Modern Dentistry';
    const defaultDescription = 'Smile Care Dental Surgery in Kottawa offers world-class dental services including implants, cosmetic dentistry, orthodontics, and more via www.iimplants.lk.';
    const defaultKeywords = 'dental implants, dentist sri lanka, kottawa dental, cosmetic dentistry, smile care, iimplants.lk';
    const defaultImage = '/images/gallery-reception.png';
    const domain = 'https://www.iimplants.lk';

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{title ? `${title} | ${siteTitle}` : siteTitle}</title>
            <meta name='description' content={description || defaultDescription} />
            <meta name='keywords' content={keywords || defaultKeywords} />
            <link rel="canonical" href={url ? `${domain}${url}` : domain} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url ? `${domain}${url}` : domain} />
            <meta property="og:title" content={title || siteTitle} />
            <meta property="og:description" content={description || defaultDescription} />
            <meta property="og:image" content={image ? `${domain}${image}` : `${domain}${defaultImage}`} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={url ? `${domain}${url}` : domain} />
            <meta name="twitter:title" content={title || siteTitle} />
            <meta name="twitter:description" content={description || defaultDescription} />
            <meta name="twitter:image" content={image ? `${domain}${image}` : `${domain}${defaultImage}`} />
        </Helmet>
    );
};

export default SEO;
